import { NgModule } from '@angular/core';
import { ScwMatCheckboxComponent } from './scw-mat-checkbox.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [MatCheckboxModule, CommonModule, FormsModule],
  exports: [ScwMatCheckboxComponent],
  declarations: [ScwMatCheckboxComponent],
})
export class ScwMatCheckboxModule {}
